/* =========================================================
   ABCD PRODUCTION HOUSE
   GLOBAL ANIMATION SYSTEM
   ========================================================= */

document.addEventListener("DOMContentLoaded", () => {

  const revealElements = document.querySelectorAll(
    ".reveal, .reveal-heading, .reveal-subheading, .reveal-stagger"
  );

  if (!revealElements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          entry.target.classList.add("is-visible");

          observer.unobserve(entry.target);

        }

      });

    },
    {
      threshold: 0.15
    }
  );

  revealElements.forEach((element) => {
    observer.observe(element);
  });

});
/* =========================================================
   ABCD — GLOBAL HEADING REVEAL
   ========================================================= */

(function () {
  function initHeadingReveal() {
    const headings = document.querySelectorAll(
      '.abc-heading-reveal'
    );

    if (!headings.length) return;

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');

          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    headings.forEach((heading) => {
      observer.observe(heading);
    });
  }

  document.addEventListener('DOMContentLoaded', initHeadingReveal);

  document.addEventListener('shopify:section:load', initHeadingReveal);
})();